import React, { useEffect, useState } from "react";
import { CFlatList } from "@app/components/Common";
import { WorldRankingSectorSetion } from "../styles";
import { loadData } from "@utils/api";
import RankingMarketItem from "./RankingMarketItem";
import WorldRankingTableHeader from "../WorldRankingTableHeader";
import { useTranslation } from "react-i18next";

const RankingMarkets = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<any[]>([]);

  useEffect(() => {
    loadData().then((res) => {
      const slice = res.slice(0, 20);
      setData(slice);
    });
  }, []);
  const rankingHeader = [
    "#",
    t("currency"),
    t("price"),
    t("24HChange"),
    t("24hTradingVolume"),
    // t('marketCap'),
    t("action"),
  ];
  const renderItem = (item: any, index: any) => {
    return <RankingMarketItem item={item} index={index} />;
  };

  return (
    <WorldRankingSectorSetion>
      <WorldRankingTableHeader data={rankingHeader} />
      <CFlatList data={data} renderItem={renderItem} itemSize={60} />
    </WorldRankingSectorSetion>
  );
};

export default React.memo(RankingMarkets);
